import http from "../../utils/http";

// 내 업무 권한 가져오기
export const getMyRole = () => {
  return new Promise((resolve, reject) => {
    http
      .get(`/employees/role`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
